/**
 * OVERRIDE MobileToolsFooter of VLT.jsx
 * REASON: Test additional links
 */

import React from 'react';
import LanguageSelector from '@plone/volto/components/theme/LanguageSelector/LanguageSelector';
import SlotRenderer from '@plone/volto/components/theme/SlotRenderer/SlotRenderer';
import Header from '@kitconcept/volto-light-theme/components/Header/Header';

export const MobileToolsFooter = () => (
  <ul className="mobile-tools">
    <li>
      <LanguageSelector fullLabel={false} />
    </li>
    <li>
      <div className="tools">
        <SlotRenderer name="headerTools" content={Header.content} />
      </div>
    </li>
  </ul>
);
